import _debounce from "lodash-es/debounce";
import get from "lodash-es/get";
import _isArray from "lodash-es/isArray";
import _isObject from "lodash-es/isObject";
import isEmpty from "lodash-es/isEmpty";
import BigNumber from "bignumber.js";
import { axiosClient } from "~/common/js/axios";
import {
  isLoginedToken,
} from "~/common/js/utils";
import { transLang } from '~/common/js/storeUtil';
import {
  TRADE_ORDER_TYPE_ENUM,
  // ENTRUST_STATE,
  unPriceList,
  PRO_TRADE_MODE_ENUM,
  BASIC_TRADE_MODE_ENUM,
  TRADE_PAGE_LAYOUT,
} from "~/common/js/const";
import { WORKER_MSG_TOPIC } from "~/common/js/workerConfig";
import { defineStore } from "pinia";
import { useIndexStore } from "./index";

let privateList = [];

const symbolFn = (state) => {
  if (!state.symbolList) {
    return;
  }
  const symbolEntity = state.symbolById[String(state.symbolInfo.symbolId)];
  if (!symbolEntity || !symbolEntity?.name) {
    return;
  }
  const [prefixName, suffixName] = symbolEntity.name.split("/");
  state.symbolInfo = Object.assign({}, state.symbolInfo, symbolEntity, {
    symbolFullName: symbolEntity.name,
    symbolSubName: prefixName,
    symbolMainName: suffixName, // 动态交易区后这么判断
  }); // 一大堆有的没的币种信息
};


let walletFn;
let walletLocale;
let walletSymbol;


// spot-map 更新允许更新时间 10min
const MAX_SPOT_MAP_CACHE_TIME = 10 * 60 * 1000;

export const useTradeStore = defineStore("trade", {
  state: () => ({
    subPriceLang: null,
    symbolInfo: {
      coinType: null, // example: ETH 16
      symbolId: 53,
      symbolFullName: null, // BMX/ETH
      symbolMainName: null, // ETH
      symbolSubName: null, // BMX
      priceScale: null, // 1000001
      depthEndPrecision: null, // 最大精度 废弃
      depthStartPrecision: null, // 最小精度 废弃

      precisionList: [], // orderbook 精度 列表
      currentPrecision: null, // orderbook 当前精度
      feeRateType: null, // 交易对类型 0 B类 1 A类

      pricePrecision: null,
      countPrecision: null,
      // @deprecated: use getter: getUpState
      upState: true,
      // marketCoinId: null, // 计价币Id
    },
    currentSymbolWallet: {
      walletVO1: {
        availableBalance: 0,
      },
      walletVO2: {
        availableBalance: 0,
      },
    }, // 币种用户余额，Objct

    //币种查询信息
    coinInfo: {
      title: null,
      subtitle: null,
      issueDate: null,
      issuePrice: null,
      circulating: null,
      totalSupply: null,
      website: null,
      whitepaper: null,
      projectDetail: null,
      projectInformation: null,
      projectAnticipation: null,
      projectEvaluation: null,
      pdfUrl: null,
      cmcUrl: null,

      hasInfo: true,
      hasEvaluation: true,

      hasRating: true,
      ratingScore: null,
      hypeScore: null,
      techScore: null,
      teamScore: null,
    },

    regionForPrivateCoin: null as string | null,

    symbolList: null, // 所有交易队信息
    symbolById: {},
    /**
     * 所有订阅实时价格的交易对信息
     * 结构是{ 2526: { symbol: 2526, c: xxx, h: xxx, increase: xxx } },
     * 2526 是交易对id
     * c 是最新成交价，h 是24小时最高价，increase 是涨幅等，具体参考后端接口文档
     * 这里只有当前订阅的交易对信息，没有订阅的不会在这个对象里
     *  */
    subscribePriceSymbolInfo: {},

    hadSubscribedPrice: false, // 是否订阅了所有交易对价格

    /**
     * 交易类型
     */
    orderType: TRADE_ORDER_TYPE_ENUM.LIMIT,
    buyPrice: null,
    buyAmount: null,
    sellPrice: null,
    sellAmount: null,
    topOrderType: null, //最新成交的类型， 吃单或者做单

    isVip: false, //
    isCountdowning: false,
    countMs: 0,
    upTime: 0,

    isAllPair: true, // 是否全部, 默认全部
    // 交易页面显示手续费白名单
    feeWhiteList: [],

    // 2088 隐私币 列表
    coinInvisibleList: [],
    // 为什么不跟privateSymbolList一样是id数组？ coinName 也要，预防后端只给name，比如 费率一些地方之类
    privateCoinList: [], // [{coinId: 2, coinName: 'BTC', countries: [XXX]}]
    // 2088 隐私交易对列表，根据隐私币 前端生成
    privateSymbolList: [], // [53,1038]
    // 专业版当前选中的是杠杆还是现货
    proTradeMode: PRO_TRADE_MODE_ENUM.SPOT,
    basicTradeMode: BASIC_TRADE_MODE_ENUM.SPOT,
    // 当前页面类型：BASIC=基础版,PRO=专业版
    tradePageLayout: TRADE_PAGE_LAYOUT.BASIC,
    spotMapUpdateTime: null,
  }),
  getters: {
    getIsLoginedFromIndex(){
      const indexStore = useIndexStore()
      return indexStore.isLogined
    },
    getLocaleFromIndex(){
      const indexStore = useIndexStore()
      return indexStore.locale
    },
    getterPrivateCoinList() {
      // 用户所属地区未准备好
      if (!this.regionForPrivateCoin) {
        return [];
      }
      return this.coinInvisibleList.filter((item) => {
        return item.countrys?.includes(this.regionForPrivateCoin); //
      });
    },
    privateCoinNames() {
      return this.getterPrivateCoinList.map(d => d.coinName);
    },
    getterPrivateSymbolList (state) {
      // 开始处理现货交易对 symbolList symbolById
      if (!state.symbolList || isEmpty(state.symbolById)) {
        return [];
      }
      const privateSymbolList = [];
      this.getterPrivateCoinList.forEach((priItem) => {
        const coinId = priItem.coinId;
        const keys = Object.keys(state.symbolById);

        keys.forEach((symbolId) => {
          if (+coinId === 1992 && +state.symbolById[symbolId].coinId === 1992) {
            // console.log('+state.symbolById[symbolId].coinId', +state.symbolById[symbolId].coinId, symbolId)
          }

          if (
            // 买卖币或者计价币
            (+state.symbolById[symbolId].coinId === +coinId ||
              +state.symbolById[symbolId].marketCoinId === +coinId) &&
            !privateSymbolList.includes(+symbolId)
          ) {
            privateSymbolList.push(+symbolId);
          }
        });
      });

      return privateSymbolList;
    },
    currentOrderTotalCounter: (state) => {
      return Object.keys(state.currentOrderCounter).reduce((total, key) => {
        total += state.currentOrderCounter[key] || 0;
        return total;
      }, 0);
    },
    symbolListExcludePrivate: (state) => {
      let symbolTemp = state.symbolList;
      const tempArr = [];
      symbolTemp.forEach((item) => {
        if (!item) {
          return;
        }
        const tempIds = [];
        const tempObj = { ...item };
        item.mappingIds.forEach((sid) => {
          if (!state.privateSymbolList.includes(+sid)) {
            tempIds.push(+sid);
          }
        });
        tempObj.mappingIds = tempIds;
        tempArr.push(tempObj);
      });
      return tempArr;
    },
    symbolByIdExcludePrivate: (state) => {
      const privateSymbolList = state.privateSymbolList;
      const tempObj = { ...state.symbolById };
      privateSymbolList.forEach((sid) => {
        delete tempObj[sid];
      });
      return tempObj;
    },
    symbolNeedUpdate(state) {
      if (!Array.isArray(state.symbolList) || state.symbolList.length === 0)
        return true;
      if (Date.now() - state.spotMapUpdateTime > MAX_SPOT_MAP_CACHE_TIME) {
        return true;
      }
      return false;
    },
  },
  actions: {
    // SET_SYMBOL_LIST(data) {
    //   console.time('SET_SYMBOL_LIST')
    //   this.symbolList = data.map((group) => {
    //     const { mappingList, coinName, coinType, ...others } = group
    //     mappingList.forEach((entity) => {
    //       Vue.set(this.symbolById, String(entity.symbol), Object.assign(entity, {
    //         coinName,
    //         coinType,
    //       }))
    //       // 临时方案：从mappingList中查找BTC/USDT交易对，获取人民币的汇率
    //       if (entity.name === 'BTC/USDT') {
    //         const exchangeRate = entity.rate / entity.c
    //         this.exchangeRate[entity.sign] = exchangeRate
    //       }
    //     })
    //     return Object.assign(others, {
    //       coinName,
    //       coinType,
    //       // perf: disable getter & setter binding
    //       mappingIds: Object.freeze(mappingList.map((d) => d.symbol)),
    //     })
    //   })

    //   symbolFn(state)
    //   console.timeEnd('SET_SYMBOL_LIST')
    // },
    SET_SYMBOL_LIST(data) {
      // console.log('SET_SYMBOL_LIST')
      // console.time('SET_SYMBOL_LIST')
      const symbolById = {};
      this.symbolList = data.map((group) => {
        const { mappingList, coinName, coinType, ...others } = group;
        mappingList.forEach((entity) => {
          Object.assign(symbolById, {
            // @perf: 这里冻结交易对详情的性能收益是巨大的
            [entity.symbol]: Object.freeze(
              Object.assign(entity, {
                coinName,
                coinType,
              })
            ),
          });

          Object.assign(this.upStateMap, {
            [entity.symbol]: entity.upState,
          });
        });
        return Object.assign(others, {
          coinName,
          coinType,
          mappingIds: Object.freeze(mappingList.map((d) => d.symbol)),
        });
      });
      this.symbolById = symbolById;
      this.spotMapUpdateTime = Date.now();
      symbolFn(state);
      // console.timeEnd('SET_SYMBOL_LIST')
    },
    CHANGE_SYMBOL_INFO(updatedList) {
      // console.time('CHANGE_SYMBOL_INFO');
      if (!this.symbolList || this.symbolList.length === 0) {
        //console.log('no trade pair')
        return;
      }
      // console.time('CHANGE_SYMBOL_INFO');
      const currentSymbolId = this.symbolInfo.symbolId;
      let needUpdateSymbolInfo;
      let subscribePriceInfo = {};
      // console.log('updatedList', updatedList.length, new Set(updatedList.map(d => d.symbolId)))
      updatedList.forEach(({ data, symbolId }) => {
        // @perf: 交易对具体信息可以冻结
        this.symbolById[symbolId] = Object.freeze({
          ...this.symbolById[symbolId],
          ...data,
        });
        if (currentSymbolId === symbolId) {
          needUpdateSymbolInfo = data;
        }
        // 更新价格订阅对象
        subscribePriceInfo[symbolId] = {
          symbol: symbolId,
          ...data,
        };
      });
      // 更新价格订阅对象
      this.subscribePriceSymbolInfo = Object.assign(
        {},
        this.subscribePriceSymbolInfo,
        subscribePriceInfo
      );
      // console.timeLog('CHANGE_SYMBOL_INFO');

      if (needUpdateSymbolInfo) {
        Object.assign(this.symbolInfo, needUpdateSymbolInfo);
        symbolFn(state);
      }
      // console.timeEnd('CHANGE_SYMBOL_INFO');
    },
    // TODO: 取消订阅价格和涨跌幅， 将这些cancel的数据从对象中删除
    CANCEL_SYMBOL_PRICE(data) {
      const list = Array.isArray(data) ? data : [data];
      const subscribePriceSymbolInfo = Object.assign(
        {},
        this.subscribePriceSymbolInfo
      );
      list.forEach((symbol) => {
        delete subscribePriceSymbolInfo[symbol];
      });

      this.subscribePriceSymbolInfo = subscribePriceSymbolInfo;
    },
    SET_SYMBOL_WALLET(data) {
      this.currentSymbolWallet = {
        walletVO1: data.walletVO1,
        walletVO2: data.walletVO2,
      };
    },
    // 更新当前订单列表交易的类型
    UPDATE_ORDER_TRADE_TAB(payload) {
      this.orderTradeTab = payload;
    },
    // 更新当前订单列表交易的类型
    UPDATE_ORDER_TRADE_TYPE(payload) {
      this.orderTradeType = payload.type;
      this.orderTradePlanType = payload.planType;
    },
    // 设置订单数量
    SET_ORDER_LIST_COUNT(payload) {
      // this.currentOrderCounter[payload.type] = payload.length
      if (payload.type === "spot_margin") {
        this.currentOrderCounter["SPOT_MARKET"] = payload.length;
      } else if (payload.type === "trigger_order") {
        this.currentOrderCounter["SPOT_TRIGGER"] = payload.length;
      } else if (payload.type === "stop_limit") {
        this.currentOrderCounter["SPOT_STOP"] = payload.length;
      }
    },
    // 设置杠杆仓位数量
    SET_MARGIN_ASSETS_POSITIONS_COUNT(payload) {
      this.marginAssetsPositionsCounter = payload;
    },
    SET_SUBSCRIPTED_PRICE(data) {
      this.hadSubscribedPrice = data.isSub;
      this.subPriceLang = data.lang;
    },
    SET_COININFO(data) {
      const coinInfo = {};
      if (!data || !data.details) {
        coinInfo.hasInfo = false;
      } else {
        coinInfo.hasInfo = true;
        coinInfo.title = get(data, ["details", "coinAbbreviation"]);
        coinInfo.subtitle = get(data, ["details", "coinFullName"]);
        coinInfo.iconUrl = get(data, ["iconUrl"]);
        coinInfo.issueDate = get(data, ["details", "issueDate"], "-");
        coinInfo.issuePrice = get(data, ["details", "issuePrice"], "-");
        coinInfo.circulating = get(data, ["details", "circulating"], "-");
        coinInfo.totalSupply = get(data, ["details", "totalSupply"], "-");
        coinInfo.website = get(data, ["details", "websiteUrl"]);
        coinInfo.whitepaper = get(data, ["details", "whitePaperUrl"]);
        coinInfo.cmcUrl = get(data, ["cmcUrl"]);
        coinInfo.projectDetail = get(data, [
          "details",
          "projectDetailedIntroduction",
        ]);

        if (data.rating && data.rating.levelResult) {
          coinInfo.hasEvaluation = true;
        } else {
          coinInfo.hasEvaluation = false;
        }
        if (data.rating) {
          coinInfo.projectInformation = get(data, ["rating", "description"]);
          coinInfo.projectEvaluation = get(data, ["rating", "levelResult"]);
          coinInfo.projectAnticipation = get(data, ["rating", "anticipation"]);
          coinInfo.pdfUrl = get(data, ["rating", "pdfUrl"]);
          coinInfo.tokenEcoScore = get(data, ["rating", "ecologyScore"]);
          coinInfo.tokenSubjectScore = get(data, ["rating", "subjectScore"]);
          coinInfo.tokenTeamScore = get(data, ["rating", "teamScore"]);
        }
        if (data.ratingScore) {
          coinInfo.hasRating = true;
          coinInfo.ratingScore = get(data, ["ratingScore", "rating"]);
          coinInfo.hypeScore = get(data, ["ratingScore", "hypeScore"]);
          coinInfo.techScore = +get(data, ["ratingScore", "techScore"]);
          coinInfo.teamScore = +get(data, ["ratingScore", "teamScore"]);
        } else {
          coinInfo.hasRating = false;
        }
      }
      this.coinInfo = coinInfo;
    },
    SET_ISVIP(data) {
      this.isVip = data;
    },
    SET_ISCOUNTING(isCounting) {
      this.isCountdowning = isCounting;
      if (!isCounting) {
        this.upStateMap[this.symbolInfo.symbol] = true;
      }
    },
    SET_COUNTMS(data) {
      this.countMs = data.countMs;
      this.upTime = data.upTime;
    },
    SET_ORDERS_ID(isAllPair) {
      if (isAllPair) {
        this.currentOrder.config.tradeMappingId = null;
        this.historyOrder.config.tradeMappingId = null;
        this.completeOrder.config.tradeMappingId = null;
      } else {
        this.currentOrder.config.tradeMappingId = this.symbolInfo.symbol;
        this.historyOrder.config.tradeMappingId = this.symbolInfo.symbol;
        this.completeOrder.config.tradeMappingId = this.symbolInfo.symbol;
      }
    },
    SET_ALL_PAIR(data) {
      this.isAllPair = data;
    },
    // 新加逻辑，保证最新价格一致
    SET_LAST_PRICE(price) {
      const precision = BigNumber(this.symbolInfo.rate).dp();
      this.symbolInfo.rate = BigNumber(this.symbolInfo.rate)
        .div(this.symbolInfo.c)
        .times(price)
        .toFixed(precision);
      this.symbolInfo.c = price;
      // this.symbolInfo.rate = (data * ratio).toFixed(2)
    },
    // 设置交易手续费白名单
    SET_FEE_WHITE_LIST(data) {
      this.feeWhiteList = data;
    },
    SET_REGION(region) {
      if (region) {
        this.regionForPrivateCoin = region
      }
    },
    // 简单起见，不用getter
    SET_PRIVATE_COIN_LIST(_data) {
      if (!privateList) {
        return;
      }
      // 用户所属地区未准备好
      if (!window.currentCountryCode) {
        return;
      }
      privateList = privateList.filter((item) => {
        return item.countrys?.includes(window.currentCountryCode);
      });
      this.privateCoinList = this.privateCoinList.concat(privateList);
      // 开始处理现货交易对 symbolList symbolById
      if (!this.symbolList || isEmpty(this.symbolById)) {
        return;
      }
      privateList.forEach((priItem) => {
        const coinId = priItem.coinId;
        const keys = Object.keys(this.symbolById);
        keys.forEach((symbolId) => {
          if (
            // 买卖币或者计价币
            (+this.symbolById[symbolId].coinId === +coinId ||
              +this.symbolById[symbolId].marketCoinId === +coinId) &&
            !this.privateSymbolList.includes(+symbolId)
          ) {
            this.privateSymbolList.push(+symbolId);
          }
        });
      });
    },
    // 设置专业版交易模式
    SET_PRO_TRADE_MODE(data) {
      this.proTradeMode = data;
    },
    // 设置订阅价格的交易对信息 subscribePriceSymbolInfo
    SET_SUBSCRIBE_PRICE_SYMBOL_INFO(data) {
      this.subscribePriceSymbolInfo = data;
    },
    // 设置普通版交易模式
    SET_BASIC_TRADE_MODE(data) {
      this.basicTradeMode = data;
    },
    // 设置页面类型
    SET_TRADE_PAGE_LAYOUT(data) {
      this.tradePageLayout = data;
    },
    // 设置隐私币列表
    SET_COIN_INVISIBLE_LIST(data) {
      this.coinInvisibleList = data;
    },
    /**
     * 除首页，trade页面，其他页面要用到 state symbolById, 需先判断 isEmpty, then dispatch
     * @param {*}
     * @returns
     */
    async getSymbolList() {
      const indexStore = useIndexStore()

      const ret = await axiosClient({
        url: "/gw-api/ds/web/spot-map",
        method: "GET",
        params: {
          local: transLang(this.getLocaleFromIndex, indexStore),
        },
      });

      if (ret?.success) {
        if (!ret.data.result || ret.data.result.length === 0) {
          console.log("no trade pair");
          return;
        }
        this.SET_SYMBOL_LIST(ret.data.result);
      }
    },
    /**
     * [getCoinInfo 获取币种查询信息]
     */
    async getCoinInfo() {
      const indexStore = useIndexStore()
      const timestamp = new Date().getTime();
      const params = {
        lang: transLang(this.getLocaleFromIndex, indexStore),
        timestamp,
        type: "TOKEN_INSIGHT",
        coinName: this.symbolInfo.symbolSubName,
      };
      let ret;
      try {
        ret = await axiosClient({
          method: "GET",
          url: "/gw-api/ds/find_coin_details",
          headers: { noMessageList: [3, -3201] },
          params,
        });
      } catch (e) {
        this.SET_COININFO(null);
        console.log(e);
      }

      if (ret && ret?.success && ret.data) {
        if (
          !ret.data.cmcUrl &&
          !ret.data.details &&
          !ret.data.iconUrl &&
          !ret.data.rating &&
          !ret.data.ratingScore
        ) {
          this.SET_COININFO(null);
        } else {
          this.SET_COININFO(ret.data);
        }
      } else {
        this.SET_COININFO(null);
      }
    },

    /**
     * [getSymbolWallet 获取币种余额 V3 新增 替代 user_assets]
     */
    async getSymbolWallet() {
      const lang = this.getLocaleFromIndex;
      const indexStore = useIndexStore()
      const langParam = transLang(lang, indexStore);
      const params = {
        local: langParam,
        symbol: this.symbolInfo.symbolId,
      };

      // 增加函数节流
      if (
        !walletFn ||
        walletSymbol !== this.symbolInfo.symbolId ||
        walletLocale !== langParam
      ) {
        walletSymbol = this.symbolInfo.symbolId;
        walletLocale = langParam;

        walletFn = _debounce(async () => {
          if (!isLoginedToken()) {
            return;
          }
          // const token = Cookies.get("accessToken");

          const ret = await axiosClient({
            url: '/gw-api/asset-gateway/spot/balance/trade',
            method: "get",
            // headers: {
            //   Authorization: token,
            // },
            params,
          });
          if (ret?.success) {
            this.SET_SYMBOL_WALLET(ret.data);
          }
        }, 1000);
        walletFn();
      } else {
        walletFn();
      }
    },

    /**
     * [loginThen 交易页登录之后，产生的动作]
     * @param  {[type]} payload   [description]
     */
    loginThen(payload) {
      // 获取余额

      this.getSymbolWallet();
      if (!(payload && payload.isMargin)) {
        this.getCurrentOrder();
        this.getHistoryOrder();
      }
      // dispatch('getCompleteOrder');
    },

    /**
     * [subscribeAllCoin 订阅所有币种实时价格 会存到 this.trade.symbolList]
     * [注意this.trade.hadSubscribedPrice 这个状态]
     * @param  {[type]} state     [description]
     * @param  {[type]} commit    [description]
     * @param  {[type]} rootState [description]
     * @param  {[type]} payload   [description]
     * @return {[type]}           [description]
     */
    subscribeAllCoin() {
      if (!this.symbolList || this.symbolList.length === 0) {
        console.log("no trade pair");
        return;
      }

      this.SET_SUBSCRIPTED_PRICE({
        isSub: true,
        lang: unPriceList.includes(this.getLocaleFromIndex) ? "en" : this.getLocaleFromIndex,
      });

      // cancelSeriesWsItems(websocketSub, 'priceBatch')
      const indexStore = useIndexStore()
      const local = unPriceList.includes(this.getLocaleFromIndex)
        ? "en_US"
        : transLang(this.getLocaleFromIndex, indexStore);

      // 订阅所有行情数据
      // priceBatch 后端文档中没有，属于前端冗余字段，为了保持格式一致，不影响功能
      // https://bitmart.atlassian.net/wiki/spaces/DEVELOPMEN/pages/1924595823/WS
      this.$worker.ws.emit("message", {
        type: WORKER_MSG_TOPIC.get("SUBSCRIBE"),
        payload: [
          "priceBatch",
          {
            event: "addChannel",
            parameters: { type: "all_ticker", sign: local },
          },
        ],
      });
    },

    /**
     * 订阅多个币种实时价格，单币种订阅也适用，只是传入的是[单个币种id]
     * @param {*} param0
     * @param {*} payload
     * @description payload.symbolIds 为多个币种id，['53', '1012']
     * @description payload.unSymbolIds 非必传，为要取消订阅的多个币种id，如果传了，会跟 symbolIds 做对比，订阅新增部分，取消订阅删除部分
     * @description payload.skipCurSymbol 非必传，为 true 时，会跳过当前币种，不去发起订阅/取消订阅
     * @returns
     */
    subscribeCoins(payload) {
      if (!this.symbolList || this.symbolList.length === 0) {
        console.log("no trade pair");
        return;
      }
      if (
        !payload ||
        !Array.isArray(payload.symbolIds) ||
        payload.symbolIds.length === 0
      ) {
        console.log("no symbolIds");
        return;
      }
      const { symbolIds, unSymbolIds } = payload;
      let addSymbolIds = symbolIds;
      let delSymbolIds = [];
      // 如果传了 unSymbolIds，就要做对比，订阅新增部分，取消订阅删除部分
      if (unSymbolIds) {
        addSymbolIds = symbolIds.filter((id) => !unSymbolIds.includes(id));
        delSymbolIds = unSymbolIds.filter((id) => !symbolIds.includes(id));
        // 如果skipCurSymbol为true，就跳过this.trade.symbolInfo.symbol
        if (payload.skipCurSymbol && this.symbolInfo?.symbol) {
          addSymbolIds = addSymbolIds.filter(
            (id) => id !== this.symbolInfo.symbol
          );
          delSymbolIds = delSymbolIds.filter(
            (id) => id !== this.symbolInfo.symbol
          );
        }
      }

      // 如果delSymbolIds有值，就取消订阅
      if (delSymbolIds.length > 0) {
        this.unsubscribeCoins({ symbolIds: delSymbolIds });
      }

      if (addSymbolIds.length === 0) {
        return;
      }
      // 修改store的subscribePriceSymbolInfo
      const subscribeSymbolInfo = Object.assign(
        {},
        this.subscribePriceSymbolInfo
      );
      // 即将做最后一次过滤
      const finalAddSymbolIds = [];
      addSymbolIds.forEach((id) => {
        if (!subscribeSymbolInfo[id]) {
          // 如果没有订阅过，就添加到subscribeSymbolInfo，同时添加到finalAddSymbolIds
          subscribeSymbolInfo[id] = {};
          finalAddSymbolIds.push(id);
        } else if (!subscribeSymbolInfo[id]?.c) {
          // 如果已经在symbolInfo里了，但是没有c值，就添加到finalAddSymbolIds
          // 进入这个流程的应该是重试订阅的流程
          finalAddSymbolIds.push(id);
        }
      });
      if (finalAddSymbolIds.length === 0) {
        return;
      }
      this.SET_SUBSCRIBE_PRICE_SYMBOL_INFO(subscribeSymbolInfo);
      const indexStore = useIndexStore()
      this.$worker.ws.emit("message", {
        type: WORKER_MSG_TOPIC.get("SUBSCRIBE"),
        payload: [
          "price_batch",
          {
            symbol: finalAddSymbolIds.join(","),
            local: transLang(this.getLocaleFromIndex, indexStore),
          },
          false,
        ],
      });
    },

    // 取消订阅多个币种实时价格, 单币种取消订阅也适用，只是传入的是[单个币种id]
    unsubscribeCoins(payload) {
      if (!this.symbolList || this.symbolList.length === 0) {
        console.log("no trade pair");
        return;
      }
      if (
        !payload ||
        !Array.isArray(payload.symbolIds) ||
        payload.symbolIds.length === 0
      ) {
        console.log("no symbolIds");
        return;
      }
      const { symbolIds } = payload;
      this.CANCEL_SYMBOL_PRICE(symbolIds);
      const indexStore = useIndexStore()
      this.$worker.ws.emit("message", {
        type: WORKER_MSG_TOPIC.get("UNSUBSCRIBE"),
        payload: [
          "price_batch",
          {
            symbol: symbolIds.join(","),
            local: transLang(this.getLocaleFromIndex, indexStore),
          },
          true,
        ],
      });
    },

    // 取消当前所有价格订阅
    unsubscribeAllCoin() {
      const symbolIds = Object.keys(this.subscribePriceSymbolInfo);
      if (symbolIds.length === 0) {
        return;
      }
      this.unsubscribeCoins({ symbolIds });
    },

    // 检查后端返回的当前订阅列表，和前端的订阅列表是否一致，有缺失需要补发一次订阅
    checkSubscribeSymbol(payload) {
      if (!payload?.currentSymbols || !Array.isArray(payload.currentSymbols)) {
        return;
      }
      const { currentSymbols } = payload;
      const subscribeSymbolIds = Object.keys(this.subscribePriceSymbolInfo);
      const diffSymbolIds = subscribeSymbolIds.filter(
        (id) => !currentSymbols.includes(String(id))
      );
      if (diffSymbolIds.length > 0) {
        // console.log('checkSubscribeSymbol', diffSymbolIds)
        this.subscribeCoins({ symbolIds: diffSymbolIds });
      }
    },

    // 判断当前币种是否已开发交易
    async getUpState() {
      const ret = await axiosClient({
        method: "GET",
        url: "/gw-api/ds/up-state",
        params: {
          symbolId: this.symbolInfo.symbol,
        },
      });

      if (ret?.success) {
        this.upTime = ret.data.upTime;
        this.serverTime = ret.data.serverTime;

        // 可开放时间时小于服务器时间时
        // 已开放交易
        if (ret.data.upTime - ret.data.serverTime <= 0) {
          this.SET_ISCOUNTING(false);
          this.SET_COUNTMS({
            upTime: 0,
            countMs: 0,
          });
        } else {
          this.SET_COUNTMS({
            upTime: ret.data.upTime,
            countMs: (ret.data.upTime - ret.data.serverTime) * 1000,
          });
          this.SET_ISCOUNTING(true);
          // 看看是否为白名单
          this.getVipMember();
        }
      }
    },

    async getVipMember() {
      if (!isLoginedToken()) {
        return;
      }
      const ret = await axiosClient({
        method: "GET",
        url: "/gw-api/ds/up-member",
        params: {
          symbolId: this.symbolInfo.symbol,
        },
        // headers: {
        //   Authorization: Cookies.get("accessToken"),
        // },
      });

      if (ret?.success && ret.data.upMember) {
        this.SET_ISVIP(true);
      } else {
        this.SET_ISVIP(false);
      }
    },

    // 获取交易页面费用显示白名单
    async getTradeFeeWhiteList() {
      const ret = await axiosClient({
        method: "GET",
        url: "/gw-api/user-center/settings/communal/forbidden/country/get",
        params: {
          bizType: "fee:display:whitelist",
        },
      });

      if (ret?.success) {
        this.SET_FEE_WHITE_LIST(ret?.data?.countryList || []);
      }
    },
    async getPrivateList() {
      const ret = await axiosClient({
        method: "GET",
        url: "/gw-api/ds/find_coin_invisible",
      });

      if (ret?.success) {
        const privateList = ret?.data?.list || [];
        this.SET_COIN_INVISIBLE_LIST(privateList);
        this.SET_PRIVATE_COIN_LIST(privateList);
      }
    },
  },
});
